// components/News.jsx
import axios from "axios";
import React, { useEffect, useState } from "react";

const News = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    title_ar: "",
    date: "",
    body: "",
    body_ar: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [flag, setFlag] = useState(false);
  const [newsItems, setNewsItems] = useState([
    {
      id: 1,
      title: "New Library Management System Launch",
      date: "2024-01-15",
      body: "We are excited to announce the launch of our new library management system that will revolutionize how we organize and access educational resources.",
      image: "/api/placeholder/400/250",
      createdAt: "2024-01-15",
      views: 1245,
    },
    {
      id: 2,
      title: "Annual Training Conference 2024",
      date: "2024-02-20",
      body: "Join us for the most anticipated training conference of the year featuring industry experts and innovative learning methodologies.",
      image: "/api/placeholder/400/250",
      createdAt: "2024-01-10",
      views: 892,
    },
    {
      id: 3,
      title: "Digital Resources Expansion",
      date: "2024-01-25",
      body: "Our digital library has expanded with over 500 new titles across various categories to better serve our community.",
      image: "/api/placeholder/400/250",
      createdAt: "2024-01-05",
      views: 567,
    },
  ]);
  const [image, setImage] = useState(null);

  // Handle Add/Edit Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isEditing && editingNews) {
      // Update existing news

      const formDataRequest = new FormData();
      formDataRequest.append("news_id", editingNews.id);
      formDataRequest.append("title", formData.title);
      formDataRequest.append("title_ar", formData.title_ar);
      formDataRequest.append("date", formData.date);
      formDataRequest.append("body", formData.body);
      formDataRequest.append("body_ar", formData.body_ar);
      if (image) formDataRequest.append("image", image);

      await axios.patch(
        process.env.REACT_APP_BASE_URL + "news/update-news",
        formDataRequest
      );
      setFlag(!flag);
    } else {
      // Add new news
      const formDataRequest = new FormData();
      formDataRequest.append("title", formData.title);
      formDataRequest.append("title_ar", formData.title_ar);
      formDataRequest.append("date", formData.date);
      formDataRequest.append("body", formData.body);
      formDataRequest.append("body_ar", formData.body_ar);
      if (formData.image) formDataRequest.append("image", formData.image);

      await axios.post(
        process.env.REACT_APP_BASE_URL + "news/add-news",
        formDataRequest
      );
      setFlag(!flag);
    }

    resetForm();
  };

  // Handle Edit
  const handleEdit = (news) => {
    setFormData({
      title: news.title,
      title_ar: news.title_ar,
      date: news.date,
      body: news.body,
      body_ar: news.body_ar,
      image: null,
    });
    setImagePreview(news.image);
    setEditingNews(news);
    setIsEditing(true);
    setIsAdding(true);
  };

  // Handle Delete
  const handleDelete = async (newsId) => {
    // setNewsItems(newsItems.filter((n) => n.id !== newsId));
    await axios.delete(process.env.REACT_APP_BASE_URL + "news/delete-news", {
      params: {
        news_id: newsId,
      },
    });
    setFlag(!flag);
  };

  // Reset form and states
  const resetForm = () => {
    setFormData({ title: "", date: "", body: "", image: null });
    setImagePreview(null);
    setIsAdding(false);
    setIsEditing(false);
    setEditingNews(null);
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files.length > 0) {
      const file = files[0];
      if (isEditing) {
        setImage(file);
      } else {
        setFormData({
          ...formData,
          image: file,
        });
      }

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // Format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Get relative time
  const getRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 1) return "Yesterday";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return formatDate(dateString);
  };

  // Get news status color
  const getNewsStatus = (newsDate) => {
    const date = new Date(newsDate);
    const today = new Date();
    const diffTime = date - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 7)
      return { color: "bg-green-100 text-green-800", text: "Upcoming" };
    if (diffDays >= 0)
      return { color: "bg-blue-100 text-blue-800", text: "Soon" };
    return { color: "bg-gray-100 text-gray-800", text: "Published" };
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BASE_URL + "news/get-all-news")
      .then((res) => setNewsItems(res.data.data));
  }, [flag]);

  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total News</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {newsItems.length}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📰</span>
            </div>
          </div>
        </div>

        {/* <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Views</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {newsItems.reduce((sum, item) => sum + item.views, 0)}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">👁️</span>
            </div>
          </div>
        </div> */}

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Upcoming News</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {
                  newsItems.filter((item) => {
                    const newsDate = new Date(item.date);
                    const today = new Date();
                    return newsDate > today;
                  }).length
                }
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">🆕</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Most Viewed</p>
              <p className="text-lg font-bold text-gray-800 mt-2 truncate">
                {newsItems.reduce(
                  (max, item) => (item.views > max.views ? item : max),
                  newsItems[0]
                )?.title || "No news"}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">🔥</span>
            </div>
          </div>
        </div>
      </div>

      {/* Header with Add Button */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            News & Announcements
          </h2>
          <p className="text-gray-600 mt-1">
            Manage your news articles and announcements
          </p>
        </div>
        <button
          onClick={() => setIsAdding(true)}
          className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center space-x-2 group"
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            +
          </span>
          <span>Add News</span>
        </button>
      </div>

      {/* Add/Edit News Form Modal */}
      {isAdding && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl transform animate-scale-in max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-green-200 bg-gradient-to-r from-green-50 to-green-100 rounded-t-2xl">
              <h3 className="text-xl font-bold text-gray-800">
                {isEditing ? "Edit News" : "Add New News"}
              </h3>
              <p className="text-green-600 text-sm mt-1">
                {isEditing
                  ? "Update the news details"
                  : "Create a new news article or announcement"}
              </p>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              {/* Image Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  News Image
                </label>
                <div className="flex items-center space-x-6">
                  <div className="w-40 h-32 bg-green-100 rounded-lg border-2 border-dashed border-green-300 flex items-center justify-center overflow-hidden">
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="Preview"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <span className="text-green-400 text-3xl">📷</span>
                    )}
                  </div>
                  <div className="flex-1">
                    <input
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      Upload a news image (JPEG, PNG, WebP)
                    </p>
                  </div>
                </div>
              </div>

              {/* Title Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  News Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter news title"
                />
              </div>

              {/* Title Arabic Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  News Title Arabic *
                </label>
                <input
                  type="text"
                  name="title_ar"
                  value={formData.title_ar}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter news title"
                />
              </div>

              {/* Date Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  News Date *
                </label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                />
              </div>

              {/* Body Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  News Content *
                </label>
                <textarea
                  name="body"
                  value={formData.body}
                  onChange={handleChange}
                  required
                  rows={6}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 resize-vertical"
                  placeholder="Enter news content..."
                />
                <p className="text-sm text-gray-500 mt-2">
                  Write the full content of your news article or announcement
                </p>
              </div>

              {/* Body Arabic Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  News Content Arabic *
                </label>
                <textarea
                  name="body_ar"
                  value={formData.body_ar}
                  onChange={handleChange}
                  required
                  rows={6}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 resize-vertical"
                  placeholder="Enter news content..."
                />
                <p className="text-sm text-gray-500 mt-2">
                  Write the full content of your news article or announcement
                </p>
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  {isEditing ? "Update News" : "Publish News"}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* News Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {newsItems.map((news, index) => {
          const status = getNewsStatus(news.date);
          return (
            <div
              key={news.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 group animate-fade-in border border-green-100"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* News Image */}
              <div className="h-48 bg-gradient-to-br from-green-100 to-green-200 relative overflow-hidden">
                <div className="w-full h-full flex items-center justify-center">
                  <span className="text-6xl text-green-600">📰</span>
                </div>
                <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1">
                  <button
                    onClick={() => handleEdit(news)}
                    className="w-8 h-8 bg-white text-green-600 rounded-full flex items-center justify-center hover:bg-green-50 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                    title="Edit News"
                  >
                    <svg
                      className="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </button>
                  <button
                    onClick={() => handleDelete(news.id)}
                    className="w-8 h-8 bg-white text-red-600 rounded-full flex items-center justify-center hover:bg-red-50 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                    title="Delete News"
                  >
                    <svg
                      className="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
                <div className="absolute top-3 left-3">
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${status.color}`}
                  >
                    {status.text}
                  </span>
                </div>
              </div>

              {/* News Details */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm text-green-600 font-medium">
                    {formatDate(news.date)}
                  </span>
                  <span className="text-sm text-gray-500 flex items-center space-x-1">
                    <span>👁️</span>
                    <span>{news.views}</span>
                  </span>
                </div>

                <h3 className="text-lg font-bold text-gray-800 mb-3 group-hover:text-green-700 transition-colors duration-200 line-clamp-2">
                  {news.title}
                </h3>

                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {news.body}
                </p>

                <div className="flex items-center justify-between text-xs text-gray-500">
                  <span>Posted {getRelativeTime(news.createdAt)}</span>
                  <span className="flex items-center space-x-1">
                    <span>📅</span>
                    <span>{formatDate(news.createdAt)}</span>
                  </span>
                </div>

                {/* Action Buttons */}
                <div className="flex space-x-2 mt-4">
                  <button className="flex-1 bg-green-50 text-green-600 py-2 px-3 rounded-lg font-medium hover:bg-green-100 transition-colors duration-200 text-sm">
                    Read More
                  </button>
                  <button className="flex-1 bg-blue-50 text-blue-600 py-2 px-3 rounded-lg font-medium hover:bg-blue-100 transition-colors duration-200 text-sm">
                    Share
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        {/* Add New News Card */}
        <div
          className="border-2 border-dashed border-green-300 rounded-2xl p-8 text-center hover:border-green-500 hover:bg-green-50 transition-all duration-300 cursor-pointer group min-h-[400px] flex items-center justify-center"
          onClick={() => setIsAdding(true)}
        >
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-200 transition-colors duration-200">
            <span className="text-2xl text-green-600 group-hover:scale-110 transition-transform duration-200">
              +
            </span>
          </div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2 group-hover:text-green-700 transition-colors duration-200">
            Add New News
          </h3>
          <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors duration-200">
            Create a new news article or announcement
          </p>
        </div>
      </div>

      {/* Empty State */}
      {newsItems.length === 0 && (
        <div className="text-center py-16">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl text-green-600">📰</span>
          </div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No news articles yet
          </h3>
          <p className="text-gray-500 mb-6 max-w-md mx-auto">
            Start sharing updates and announcements with your community by
            creating your first news article.
          </p>
          <button
            onClick={() => setIsAdding(true)}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            Create First News
          </button>
        </div>
      )}

      {/* Quick Stats Footer */}
      {newsItems.length > 0 && (
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-6 text-white">
          <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-center">
            <div>
              <p className="text-sm opacity-90">Total Articles</p>
              <p className="text-2xl font-bold">{newsItems.length}</p>
            </div>
            {/* <div>
              <p className="text-sm opacity-90">Total Views</p>
              <p className="text-2xl font-bold">
                {newsItems.reduce((sum, item) => sum + item.views, 0)}
              </p>
            </div> */}
            <div>
              <p className="text-sm opacity-90">Upcoming</p>
              <p className="text-2xl font-bold">
                {
                  newsItems.filter((item) => new Date(item.date) > new Date())
                    .length
                }
              </p>
            </div>
            {/* <div>
              <p className="text-sm opacity-90">Avg. Views</p>
              <p className="text-2xl font-bold">
                {Math.round(
                  newsItems.reduce((sum, item) => sum + item.views, 0) /
                    newsItems.length
                )}
              </p>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default News;
